import { defineMessages } from 'react-intl'

export default defineMessages({
  beautify: {
    id: 'SpaceAppBuilderFeaturesPage.codeEditor.beautify',
    defaultMessage: 'Beautify Code'
  }
})
